import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import CountryDropdown from 'cirrus/Dropdown/Country';

const AddressCountry = ({
  name,
  countryName,
  countryCode,
  onSelectChange,
  onInputChange,
  className,
  dropdownClassName,
  ...rest
}) => (
  <Fragment>
    <CountryDropdown
      className={dropdownClassName}
      countryName={countryName}
      countryCode={countryCode}
      onSelectChange={onSelectChange}
      onInputChange={onInputChange}
      {...rest}
    />

    <input name={`${name}`} type="hidden" className={className} readOnly value={countryName} />
    <input name={`${name}_code`} type="hidden" className={className} readOnly value={countryCode} />
  </Fragment>
);

AddressCountry.defaultProps = {
  countryName: '',
  countryCode: '',
};

AddressCountry.propTypes = {
  name: PropTypes.string.isRequired,
  countryName: PropTypes.string,
  countryCode: PropTypes.string,
};

export default AddressCountry;
